export enum OauthProvider {
    Salesforce = 'salesforce',
    SalesforceCompany = 'salesforce_company',
    Hubspot = 'hubspot',
    HubspotLite = 'hubspot_lite',
    HubspotFilters = 'hubspot_filters',
    HubspotBceEnrichment = 'hubspot_bce_enrichment',
    HubspotEnrichment = 'hubspot_enrichment',
    SalesLoft = 'salesloft',
    Outreach = 'outreach',
    Marketo = 'Marketo',
    Dynamics = 'dynamics',
    DynamicsCompany = 'dynamics_company',
    Zoho = 'zoho',
    ZohoCompany = 'zoho_company',
    Google = 'google',
    Microsoft = 'microsoft'
}
